import { makeAutoObservable, runInAction } from "mobx";

import { CreateInviteBodyKind, type Invite } from "@/api";
import { InviteApi } from "@/models/api/InviteApi";
import { getUrlOrigin } from "@/urls";

import type { TeamModel } from "./TeamModel";
import type { RootStore } from "@/store";

export class InviteModel {
  private rootStore: RootStore;

  private api: InviteApi;

  team: TeamModel;

  constructor(rootStore: RootStore, inviteData: Invite, team: TeamModel) {
    this.rootStore = rootStore;
    this.api = new InviteApi(inviteData);
    this.team = team;
    makeAutoObservable(this);
  }

  get email() {
    return this.api.inviteData.email;
  }

  get user() {
    return this.api.inviteData.user;
  }

  get token() {
    return this.api.inviteData.token;
  }

  get kind() {
    return this.api.inviteData.kind;
  }

  get link() {
    if (this.kind === CreateInviteBodyKind.reusable_link) {
      return `${getUrlOrigin()}/accept-invite/${this.token}`;
    }
    return null;
  }

  async revoke() {
    const res = await this.api.revoke();
    if (res) {
      if (this.team.invitesUX) {
        const currentInvites = this.team.invitesUX.invites;
        runInAction(() => {
          this.team.invitesUX.invites = currentInvites.filter((i) => i.token !== this.token);
        });
      }
    }
    return res;
  }

  async resend() {
    return this.api.resend();
  }
}
